export default "__VITE_ASSET__ee0dff88__"